<script>

	import Filters from "./components/Filters.svelte";
	import Map from "./components/Map.svelte";
	
	export let ready;
	export let mapdata;
	export let filters;
	export let config;
	export let pins;	

</script>
<svelte:head>
	<script src="https://maps.googleapis.com/maps/api/js?key={config.key}&callback=initMap&libraries=&v=weekly" defer ></script>
</svelte:head>
{ #if ready }
<Map {config} {mapdata} {filters} {pins}/>
{ /if }
